(function ($) {
  $(document).ready(function () {
    $("#ch_reg_first_name").attr("placeholder", "First Name");
    $("#ch_reg_last_name").attr("placeholder", "Last Name");
    $("#ch_reg_email").attr("placeholder", "Email");
    $("#ch_reg_password").attr("placeholder", "Password");
    $("#ch_reg_phone").attr("placeholder", "Phone Number");
    $(".chContent-BPG-group-Value-Label").html("Birthday");

    $(".forget-link a").on("click", function (e) {
      e.preventDefault();
      $(".login-box").removeClass("is-active");
      $(".forget-password-box").addClass("is-active");
      return false;
    });

    $(".cancel-link a").on("click", function (e) {
      e.preventDefault();
      $(".login-box").addClass("is-active");
      $(".forget-password-box").removeClass("is-active");
      return false;
    });
  });
})(jQuery);
